import React from "react";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/sections/Hero";
import { Mission } from "@/components/sections/Mission";
import { WhoIsPaula } from "@/components/sections/WhoIsPaula";
import { BookPreview } from "@/components/sections/BookPreview";
import { AnmalGallery } from "@/components/sections/AnmalGallery";
import { AppShowcase } from "@/components/sections/AppShowcase";
import { HeldRule } from "@/components/sections/HeldRule";
import { PlushVision } from "@/components/sections/PlushVision";
import { Press } from "@/components/sections/Press";
import { Schools } from "@/components/sections/Schools";
import { Sponsors } from "@/components/sections/Sponsors";
import { Shop } from "@/components/sections/Shop";
import { Footer } from "@/components/sections/Footer";

export default function Landing() {
  return (
    <div data-testid="landing-page" className="bg-paula-cream min-h-screen">
      <Navbar />
      <main>
        <Hero />
        <Mission />
        <WhoIsPaula />
        <BookPreview />
        <AnmalGallery />
        <AppShowcase />
        <HeldRule />
        <PlushVision />
        <Press />
        <Schools />
        <Sponsors />
        <Shop />
      </main>
      <Footer />
    </div>
  );
}
